export { Campaigns as default } from 'pages/campaigns/campaigns';
